import { StoreState } from 'state/root-reducer';

export const getSubject = (state: StoreState) => state.contact.subject;

export const getCategory = (state: StoreState) => state.contact.category;
